import { useTranslation } from 'react-i18next';
import { PaneModal } from './PaneModal';
import { PaneButtons, PaneContent } from './PaneModal.styled';
import { Button } from '@plecto/ui';
import React from 'react';

type BasicModalProps = {
    title?: JSX.Element | string,
    message: string;
    onCancel: () => void;
    onSave: () => void;
}

export function ConfirmationModal({ title, message, onCancel, onSave }: BasicModalProps) {
	const { t } = useTranslation();
	return <PaneModal title={title} onClose={onCancel} forceTop>
		<PaneContent>
			{message}
		</PaneContent>
		<PaneButtons>
			<Button label={t('Cancel')} variant={'secondary'} onClick={onCancel} />
			<Button label={t('Save')} variant={'primary'} onClick={onSave} />
		</PaneButtons>
	</PaneModal>;
}
